import React from 'react';
//import Header from '../backend/layout/Header';
//import Header2 from '../backend/layout/Header2';
//import AllUser from '../backend/AllUser';
import { Container , Row , Col , Button , Alert , Form , Nav , Navbar , NavDropdown, Dropdown } from 'react-bootstrap' ;
import StatCards from './statcards'
function Dashboard() {
    return (
        <>
         <div className="my-4  container-xl">
        <div>
        <h4 style={{marginLeft:'65px', marginBottom:'30px',fontFamily:'Times New Roman' , fontWeight:'600'}}>Dashboard</h4>
        </div>
        <Container>
        
            <StatCards />
        </Container>
        </div>
        </>
   
    );

}

export default Dashboard;